import React from 'react';
import {
    Box,
    Card,
    CardHeader,
    CardContent,
    Avatar,
    Typography,
    Chip,
    Divider,
    Table,
    TableBody,
    TableRow,
    TableCell, Tooltip,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { ArrowRightIcon } from "@mui/x-date-pickers";
import moment from "moment";


const colorMap = {
    purple:    '#a259d9',
    orange:    '#f4a261',
    blue:      '#2196f3',
    green:     '#43a047',
    red:       '#e63946',
    yellow:    '#ffd600',
    teal:      '#26c6da',
    pink:      '#ec407a',
    brown:     '#8d6e63',
    gray:      '#bdbdbd',
    indigo:    '#3f51b5',
    cyan:      '#00bcd4',
    lime:      '#cddc39',
    amber:     '#ffb300',
    deepOrange:'#ff7043',
    deepPurple:'#7c43bd',
    lightBlue: '#29b6f6',
    lightGreen:'#8bc34a',
    gold:      '#ffd700',
    silver:    '#c0c0c0',
};

function ActivityLog({ activities = [], header = true, sxCard= { mt: 2 }}) {
    return (
        <>
        { activities.length > 0 && <Card sx={sxCard}>
            {header && <> <CardHeader
                avatar={
                    <Avatar sx={{ bgcolor: 'primary.main' }}>
                        <ListAltIcon />
                    </Avatar>
                }
                title={
                    <Typography variant="h6" fontWeight={600}>
                        Logs de atividades
                    </Typography>
                }
            />
            <Divider /> </>}
            <CardContent>
                <Table size="small">
                    <TableBody>
                        {activities.map((log) => (
                            <TableRow key={log.id}>
                                <TableCell align="center" sx={{ py: 2 }}>
                                    <Tooltip title={moment(log.time).format('DD/MM/YYYY [às] HH:mm:ss')}>
                                    <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                                            <AccessTimeIcon fontSize="small" color="action" />
                                            <Typography variant="caption" color="text.secondary">
                                                {moment(log.time).fromNow()}
                                            </Typography>
                                    </Box>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sx={{ py: 2 }}>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Avatar src={log?.avatar} alt={log.user} sx={{ width: 28, height: 28 }} />
                                        <Typography variant="body2">{log.user}</Typography>
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ py: 2 }}>
                                    <Typography variant="body2">{log.description}</Typography>
                                </TableCell>
                                {/*<TableCell sx={{ py: 2 }}>*/}
                                {/*    {log.field && (*/}
                                {/*        <Chip*/}
                                {/*            label={log.field}*/}
                                {/*            size="small"*/}
                                {/*            sx={{ bgcolor: '#f5f5f5', color: '#333', fontWeight: 500 }}*/}
                                {/*        />*/}
                                {/*    )}*/}
                                {/*</TableCell>*/}
                                <TableCell >
                                    <Box sx={{ py: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {log.from && (
                                        <Chip
                                            label={log.from}
                                            size="small"
                                            sx={{
                                                bgcolor: colorMap[log.from_color] || colorMap.gray,
                                                color: '#fff',
                                                fontWeight: 500,
                                            }}
                                        />
                                    )}
                                    {log.from && log.to && (
                                        <ArrowRightIcon fontSize="small" sx={{ mx: 0.5 }} />
                                    )}
                                    {log.to && (
                                        <Chip
                                            label={log.to}
                                            size="small"
                                            sx={{
                                                bgcolor: colorMap[log.to_color] || colorMap.gray,
                                                color: '#fff',
                                                fontWeight: 500,
                                            }}
                                        />
                                    )}
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card> }</>
    );
}

export default ActivityLog;